import React from "react";
import { Seo } from "../components/Seo";
import { SEO } from "../seo";
import { Strategy } from "../components/Strategy";
import { Sectors } from "../components/Sectors";

export default function StrategiePage() {
  return (
    <div className="pt-10">
      <Seo {...SEO.strategie} />
      <Strategy />
      <Sectors />
    </div>
  );
}
